import { defineMessages } from 'react-intl';

export default defineMessages({
    noPolicyChangeformsOrderings: {
        id: 'gateway.directives.gateway-formsOrderings.There are no formsOrderings associated with this policy change',
        defaultMessage: 'There are no formsOrderings associated with this policy change',
    },
    modalError: {
        id: 'formsOrdering.pages.formsOrdering-page.modal.Error',
        defaultMessage: 'Error'
    },
    errorLoadingformsOrdering: {
        id: 'formsOrdering.pages.formsOrdering-page.modal.Error loading formsOrderings',
        defaultMessage: 'Error loading formsOrderings'
    },
});
